import { ColoursObj, TicketIcon } from '@eventr/common-storybook'
import { Grid, Stack } from '@mui/material'
import { useFormatValue } from '../../hooks/useFormatValue'
import { useObjectContext } from '../providers/objectProvider'
import { CardText } from '../subComponents/cardText'

interface ITransportTimesProps {
    pick_up: string
    drop_off: string
    pick_up_location?: string
    drop_off_location?: string
    pick_up_stop?: string
    drop_off_stop?: string
}

export const TransportTimes = ({
    pick_up,
    drop_off,
    pick_up_location,
    drop_off_location,
    pick_up_stop,
    drop_off_stop,
}: ITransportTimesProps) => {
    const { formatValue } = useFormatValue()
    const { past } = useObjectContext()
    return (
        <Grid container spacing={{ xs: 1 }}>
            <Grid item xs={4}>
                <Stack direction={'column'}>
                    <CardText variant="body1">
                        {formatValue(pick_up, 'time')}
                    </CardText>
                    {pick_up_location && (
                        <CardText variant="bodySubtext">
                            {pick_up_location}
                        </CardText>
                    )}
                    {pick_up_stop && (
                        <CardText variant="bodySubtext">
                            {' '}
                            {pick_up_stop}
                        </CardText>
                    )}
                </Stack>
            </Grid>
            <Grid
                display={'flex'}
                alignItems={'center'}
                flexDirection={'column'}
                justifyContent={'center'}
                item
                xs={4}
            >
                <TicketIcon
                    iconColour={
                        past
                            ? ColoursObj.shades.shade2
                            : ColoursObj.core.secondary
                    }
                    name="Bus"
                />
            </Grid>
            <Grid item xs={4}>
                <Stack direction={'column'}>
                    <CardText variant="body1" component={'p'} textAlign={'end'}>
                        {formatValue(drop_off, 'time')}
                    </CardText>
                    {drop_off_location && (
                        <CardText
                            variant="bodySubtext"
                            component={'p'}
                            textAlign={'end'}
                        >
                            {drop_off_location}
                        </CardText>
                    )}
                    {drop_off_stop && (
                        <CardText
                            variant="bodySubtext"
                            component={'p'}
                            textAlign={'end'}
                        >
                            {drop_off_stop}
                        </CardText>
                    )}
                </Stack>
            </Grid>
        </Grid>
    )
}
